import { createIcon } from './create-icon'

export const ExpandIcon = (): SVGSVGElement => createIcon(['M15 3h6v6', 'M9 21H3v-6', 'M21 3l-7 7', 'M3 21l7-7'])
